import { PageId } from 'constants/pages'

export const enum PageIdWoofzNpday65 {
  SUBSCRIPTIONS_NPDAY_65 = PageId.SUBSCRIPTIONS_NPDAY_65,
  CHAT_UPSELL_NPDAY_65 = PageId.CHAT_UPSELL_NPDAY_65,
  UPSELL_NPDAY_65 = PageId.UPSELL_NPDAY_65,
  DOWNLOAD_NPDAY_65 = PageId.DOWNLOAD_NPDAY_65,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
